<template>
  <div class="card-employment-policies">
    <div class="table">
      <b-row class="header">
        <b-col cols="1">
          {{ $t("label_reports_managementReport_number_caption") }}
        </b-col>
        <b-col class="question">
          {{ $t("label_reports_managementReport_question_caption") }}
        </b-col>
        <b-col cols="3">
          {{ $t("label_reports_managementReport_answer_caption") }}
        </b-col>
      </b-row>
      <div v-for="(question, indexQuestion) in data" :key="question.number">
        <b-row
          v-if="
            indexQuestion < numberOfQuestion + starterQuestion &&
            indexQuestion >= starterQuestion
          "
          class="table-row"
        >
          <b-col class="number" cols="1">
            {{ $t(question.number) }}
          </b-col>
          <b-col class="question">
            {{ $t(question.label) }}
          </b-col>
          <b-col class="answer" :class="question.value_class" cols="3">
            {{ $t(question.value) }}
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardEmploymentPolicies",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    numberOfQuestion: {
      type: Number,
      default: 1000,
    },
    starterQuestion: {
      type: Number,
      default: 0,
    },
  },
  data: function () {
    return {
      styles: {
        optionList_selfAssessment_employmentPolicies_responses_always: "always",
        optionList_selfAssessment_employmentPolicies_responses_sometimes:
          "sometimes",
        optionList_selfAssessment_employmentPolicies_responses_never: "never",
        string: "",
      },
    };
  },
};
</script>
<style lang="sass" scoped>

@import "../../assets/css/variables.scss"

.card-employment-policies
  .table
    font-size: 1.0rem
    text-align: center
    .row
      margin: 5px 0
    .question
      line-height: 1.2rem
      text-align: left
    .header
      font-size: 1rem
      font-family: $font-subtitle
    .table-row
      border: 1px solid #000
      min-height: 52px
      align-items: center
    .number
      font-family: $font-subtitle
      font-size: 1.3rem
    .answer
      background-color: gray
      min-height: inherit
      display: flex
      align-items: center
      justify-content: center
      color: #fff
      font-size: 1.3rem
      font-family: $font-subtitle
      border: 2px solid #000
      border-left: 3px solid #000
    .always
      background-color: $positive-color
    .sometimes
      background-color: $intermediate-color
    .never
      background-color: $negative-color
</style>
